import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_LIST_PARAMS } from 'config';
import { FaqState } from 'types/faq';

const initialState: FaqState = {
  isLoading: false,
  faqList: {},
  faqListParams: INITIAL_LIST_PARAMS,
};

const slice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    getFaqListSuccess(state, action) {
      state.isLoading = false;
      state.faqList = action.payload;
    },

    getFaqSuccess(state, action) {
      state.isLoading = false;
      state.faq = action.payload;
    },

    setFaqListParams(state, action) {
      state.faqListParams = action.payload;
    },

    clearFaq(state) {
      state.faq = undefined;
    },

    clearFaqList(state) {
      state.faqList = {};
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  getFaqListSuccess,
  getFaqSuccess,
  setFaqListParams,
  clearFaq,
  clearFaqList,
  hasError,
} = slice.actions;
